<template>
    <div class="page-item__badge"
         v-bind:style="(badge.action || badge.hint) ? {
                        pointerEvents: 'all',
                        cursor: 'help',
                    } : null"
         v-on:click="badge.action ? $emit('action', badge.action) : null"
    >
        <icon v-bind:name="'badge-' + badge.icon" height="1em" width="auto" original />
        <div class="page-item__badge-hint"
             v-if="badge.hint"
             v-text="badge.hint"
        />
    </div>
</template>

<script>
export default {
    name: 'page-item-badge',
    props: {
        badge: {
            type: Object,
        },
    },
};
</script>

<style scoped lang="less">
@import '~theme';

.page-item__badge {
    position: relative;

    // padding: 16px;

    font-size: 3.2rem;
    &-hint {
        .typography-hint();

        position: absolute;
        right: 16px;
        top: ~'calc(100% - 12px)';

        display: none;

        width: ~'min(244px, 75vw)';
        padding: 4px;

        background: @color-gray-main;
        box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.25);

        z-index: 101;
    }
    &:hover &-hint {
        display: block;
    }

    @media @media-sm-down {
        // padding: 12px;
        &-hint {
            right: auto;
            left: 12px;
            bottom: ~'calc(100% - 8px)';
            top: auto;
        }
    }
}
</style>
